import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSuppliersList,
  fetchSuppliersCode,
  createSupplier,
  deleteSupplier,
} from "./suppliersThunk";

const suppliersSlice = createSlice({
  name: "suppliers",
  initialState: {
    suppliers: [],
    supplierCode: null,
    selectedSupplier: null,
    isEditSupplier: false,
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedSupplier: (state, action) => {
      state.selectedSupplier = action.payload;
    },
    setIsEditSupplier: (state, action) => {
      state.isEditSupplier = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // 📌 fetchSuppliersList
      .addCase(fetchSuppliersList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuppliersList.fulfilled, (state, action) => {
        state.loading = false;
        state.suppliers = action.payload;
      })
      .addCase(fetchSuppliersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 📌 fetchSuppliersCode
      .addCase(fetchSuppliersCode.fulfilled, (state, action) => {
        state.supplierCode = action.payload;
      })

      // 📌 createSupplier
      .addCase(createSupplier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSupplier.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 📌 deleteSupplier
      .addCase(deleteSupplier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSupplier.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedSupplier, setIsEditSupplier } = suppliersSlice.actions;
export default suppliersSlice.reducer;
